import { Hooper, Slide } from 'hooper'

export default {
  components: {
    Hooper,
    Slide,
  },
  props: {
    contents: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      slideIndex: 0,
    }
  },
  methods: {
    handleSlide(data) {},
    handleSlideNext() {
      this.slideIndex += 1
      if (this.slideIndex > this.contents.length - 1) {
        this.slideIndex = 0
      }
      this.$refs.slides.slideNext()
      this.$emit('slide', {
        currentSlide: this.slideIndex,
      })
    },
    handleSlidePrev() {
      this.slideIndex -= 1

      if (this.slideIndex < 0) {
        this.slideIndex = this.contents.length - 1
      }
      this.$refs.slides.slidePrev()
      this.$emit('slide', {
        currentSlide: this.slideIndex,
      })
    },
  },
}
